import { ColorOptions, Text } from '@jfs/ui-new'

interface StatusTextProps {
  text: string
}

export const StatusText = ({ text }: StatusTextProps) => {
  const COLORS = {
    SUCCESS: 'BRAND_PRIMARY_GREEN',
    FAILED: 'BRAND_PRIMARY_RED',
    INITIATED: 'YELLOW',
    PENDING: 'YELLOW',
    'PARTIALLY SUCCESS': 'YELLOW',
  } as any

  return (
    <Text fontSize={12} fontFamily="jioType-bold" color={COLORS[text] as ColorOptions}>
      {text}
    </Text>
  )
}
